import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarAdmin from "../NavbarAdmin/NavbarAdmin";
import "../ListProv/ListProv.css";
import "./ListProvAdmin.css";
import FooterIndex from "../../components/footerHomePage/footerHomePage";
import moment from "moment";
import "moment/locale/es";
import Swal from "sweetalert2";

const ListProvAdmin = () => {
  moment.locale("es"); // Establecer español como idioma

  const [initialFilter, setInitialFilter] = useState({
    idSuplier: null,
    monthFilter: null,
    year: null,
  });
  const [apiResponse, setApiResponse] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [cuit, setCuit] = useState("");
  const [typeProvider, setTypeProvider] = useState("");
  const [sales, setSales] = useState([]);
  const [filtermonth, setFilterMonth] = useState(false);
  const [filtername, setfiltername] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // Comprobar si monthFilter y year tienen valores
      if (
        initialFilter.monthFilter !== null &&
        initialFilter.year !== null &&
        initialFilter.idSuplier !== null
      ) {
        try {
          // Construir la URL con parámetros
          const response = await axios.get(
            `${process.env.REACT_APP_SALES_TOTALS_SUPPLIER}${
              initialFilter.idSuplier
            }?month=${initialFilter.monthFilter}&year=${
              initialFilter.year
            }&timestamp=${new Date().getTime()}`
          );

          // Manejar la respuesta aquí
          setApiResponse(response.data);
        } catch (error) {
          console.error("Error al obtener datos:", error);
        }
      }
    };

    fetchData();
  }, [initialFilter]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SALES_ALL_SUPPLIER
      );
      setSales(response.data);
    } catch (error) {}
  };

  const handleFilterClick = async () => {
    setfiltername(true);
    setSales([]); // Limpia las ventas al iniciar la búsqueda

    // Resetea el filtro inicial
    setInitialFilter((prev) => ({
      ...prev,
      idSuplier: null,
    }));

    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_SALES_ALL_SUPPLIER
        }?timestamp=${new Date().getTime()}`,
        {
          params: {
            fromDate: fromDate,
            toDate: toDate,
            cuit: cuit,
            typeProvider: typeProvider,
          },
        }
      );

      const data = response.data;
      setSales(data); // Actualiza el estado de sales con los datos de la respuesta

      if (data.length > 0) {
        // Actualiza el filtro inicial basándote directamente en la respuesta recibida
        setInitialFilter((prev) => ({
          ...prev,
          idSuplier: data[0].supplierId || null,
        }));
      }
    } catch (error) {
      console.error("Error fetching sales data", error);
    }
  };

  const handleFilterClickdate = async () => {
    setFilterMonth(true);
    try {
      const fromDateMoment = moment(fromDate, "YYYY-MM-DD");
      const toDateMoment = moment(toDate, "YYYY-MM-DD");

      /*--------------------------------------------------*/
      // Obtener el nombre del mes y el año en español
      const fromDateMonth = fromDateMoment.locale("es").format("MMMM");
      const fromDateYear = fromDateMoment.format("YYYY");

      const toDateMonth = toDateMoment.locale("es").format("MMMM");
      const toDateYear = toDateMoment.format("YYYY");

      // Comparar si el mes y el año son iguales
      if (fromDateMonth === toDateMonth && fromDateYear === toDateYear) {
        // Capitalizar la primera letra del mes
        const capitalizedMonth =
          fromDateMonth.charAt(0).toUpperCase() + fromDateMonth.slice(1);

        // Si el mes y el año son iguales, guardar en el filtro
        setInitialFilter((prev) => ({
          ...prev,
          monthFilter: capitalizedMonth,
          year: fromDateYear,
        }));
      }

      /*--------------------------------------------------*/

      // Calcular la diferencia en meses
      const differenceInMonths = toDateMoment.diff(fromDateMoment, "months");

      if (differenceInMonths > 3) {
        // La diferencia entre las fechas es mayor a 3 meses
        Swal.fire({
          icon: "warning",
          title: "Algo salió mal.",
          text: "La diferencia entre las fechas no puede ser mayor a 3 meses.",
        });
      } else {
        const response = await axios.get(
          process.env.REACT_APP_SALES_ALL_SUPPLIER,
          {
            params: {
              fromDate: fromDate,
              toDate: toDate,
              cuit: cuit,
              typeProvider: typeProvider,
            },
          }
        );

        setSales(response.data);
      }
    } catch (error) {}
  };

  const handlertotalmonth = (response) => {
    return (
      <div className="allboxlistprov">
        <div className="headerlistprov">
          <p
            style={{ width: "25%" }}
            className="infoprovlistletter leftlistprev firsttittle"
          >
            Mes
          </p>
          <p
            style={{ width: "25%" }}
            className="infoprovlistletter leftlistprev"
          >
            Total Prestado
          </p>
          <p
            style={{ width: "25%" }}
            className="infoprovlistletter leftlistprev"
          >
            Porcentaje de Comisión
          </p>
          <p
            style={{ width: "25%" }}
            className="infoprovlistletter leftlistprev lastittle"
          >
            Total de la Comisión
          </p>
        </div>
        <div className="headerlistprovadmin marginlistprov" /* key={index} */>
          <p className="infoprovlistletter leftlistprev2">
            {response.salesTotal.month}
          </p>
          <p className="infoprovlistletter leftlistprev2">
            {response.salesTotal.totalBorrowed}
          </p>
          <p className="infoprovlistletter leftlistprev2">
            {response.salesTotal.commissionPercentage}
          </p>
          <p className="infoprovlistletter bottonlistprev2">
            {response.salesTotal.totalCommission}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="backgounrdprov">
      <NavbarAdmin />
      <div className="allboxlistprovadmin">
        <div className="allsearch">
          <div className="boxdisplaysearch">
            <div className="inputboxadmin">
              <input
                className="inputsearchadmin"
                id="inputfromDate"
                type="date"
                placeholder="Desde"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="inputboxadmin">
              <input
                className="inputsearchadmin"
                id="inputfromDate"
                type="date"
                placeholder="Hasta"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <div id="boxbuttondate">
              <button
                id="buttondate"
                className="buttonfilteradmin"
                onClick={handleFilterClickdate}
              >
                Filtrar
              </button>
            </div>
          </div>
          <div className="boxdisplaysearchend">
            <div className="inputboxadmin">
              <input
                className="inputsearchadmin"
                type="text"
                placeholder="Buscar CUIT"
                value={cuit}
                onChange={(e) => setCuit(e.target.value)}
              />
            </div>
            <div>
              <button className="buttonfilteradmin" onClick={handleFilterClick}>
                Buscar
              </button>
            </div>
          </div>
        </div>

        <div className="allsearch2">
          <div className="boxdisplaysearch2">
            <div className="inputboxadmin">
              <input
                className="inputsearchadmin"
                type="text"
                placeholder="Buscar Comercializador"
                value={typeProvider}
                onChange={(e) => setTypeProvider(e.target.value)}
              />
            </div>
            <div>
              <button className="buttonfilteradmin" onClick={handleFilterClick}>
                Buscar
              </button>
            </div>
          </div>
        </div>

        <div className="alllistprov">
          <div className="headerlistprovadmin">
            <p className="infoprovlistletter leftlistprev firtsborder">
              Nombre del Socio
            </p>
            <p className="infoprovlistletter leftlistprev">Fecha de prestamo</p>
            <p className="infoprovlistletter leftlistprev">Total</p>
            <p className="infoprovlistletter leftlistprev">Cuotas</p>
            <p className="infoprovlistletter bottonlistprev">Comision</p>
            <p className="infoprovlistletter bottonlistprev">Comercializador</p>
            <p className="infoprovlistletter bottonlistprev lastborder">Cuit</p>
          </div>
          {sales.map((sale, index) => (
            <div className="headerlistprovadmin marginlistprov" key={index}>
              <p className="infoprovlistletter leftlistprev2">
                {sale.nameOfPersonReceivingLoan}
              </p>
              <p className="infoprovlistletter leftlistprev2">
                {moment(sale.date).format("DD-MM-YYYY")}
              </p>
              <p className="infoprovlistletter leftlistprev2">
                ${sale.amountGranted}
              </p>
              <p className="infoprovlistletter leftlistprev2">{sale.quotas}</p>
              <p className="infoprovlistletter bottonlistprev2">
                ${sale.commission}
              </p>
              <p className="infoprovlistletter bottonlistprev2">
                {sale.typeProvider}
              </p>
              <p className="infoprovlistletter bottonlistprev2">
                {sale.cuitProvider}
              </p>
            </div>
          ))}
        </div>
      </div>

      {filtername && filtermonth && apiResponse
        ? handlertotalmonth(apiResponse)
        : null}

      <FooterIndex />
    </div>
  );
};

export default ListProvAdmin;
